export default __webpack_public_path__ + "static/media/ad-6.5fb5a965.jpg";